import { useState } from 'react';
import axios from 'axios';
import { ImagePlus, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_PHOTOS = 4;

export default function PhotoGalleryUploader({ photos = [], onChange }) {
  const [uploading, setUploading] = useState(false);
  const slots = [...photos];
  while (slots.length < MAX_PHOTOS) slots.push(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (photos.length >= MAX_PHOTOS) {
      toast.error(`Massimo ${MAX_PHOTOS} foto`);
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(`${API}/upload`, fd, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const url = `${process.env.REACT_APP_BACKEND_URL}${res.data.url}`;
      onChange([...photos, url]);
      toast.success('Foto aggiunta');
    } catch {
      toast.error('Errore upload');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (idx) => {
    onChange(photos.filter((_, i) => i !== idx));
  };

  return (
    <div className="space-y-2" data-testid="gallery-uploader">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {slots.map((url, idx) => {
          if (url) {
            return (
              <div
                key={`${url}-${idx}`}
                className="relative aspect-square rounded-xl overflow-hidden bg-slate-100"
                data-testid={`gallery-photo-${idx}`}
              >
                <img src={url} alt={`Foto ${idx + 1}`} className="w-full h-full object-cover" />
                <button
                  type="button"
                  onClick={() => handleRemove(idx)}
                  className="absolute top-1 right-1 bg-black/60 hover:bg-black/80 text-white rounded-full p-1"
                  aria-label="Rimuovi foto"
                  data-testid={`gallery-remove-${idx}`}
                >
                  <X className="w-3 h-3" />
                </button>
              </div>
            );
          }
          // Empty slot - first one is upload button, others are transparent placeholders
          const isUploadable = idx === photos.length;
          if (isUploadable) {
            return (
              <label
                key={`upload-${idx}`}
                className="aspect-square rounded-xl border-2 border-dashed border-slate-300 hover:border-blue-500 hover:bg-blue-50 transition-colors flex flex-col items-center justify-center cursor-pointer text-slate-500"
                data-testid={`gallery-upload-${idx}`}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleUpload}
                  disabled={uploading}
                  className="hidden"
                />
                {uploading ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <>
                    <ImagePlus className="w-5 h-5 mb-1" />
                    <span className="text-[10px]">Aggiungi</span>
                  </>
                )}
              </label>
            );
          }
          return (
            <div
              key={`empty-${idx}`}
              className="aspect-square rounded-xl border border-dashed border-slate-200 bg-slate-50/40"
            />
          );
        })}
      </div>
      <p className="text-xs text-slate-500">
        Carica fino a {MAX_PHOTOS} foto del tuo negozio (vetrina, interno, prodotti).
      </p>
    </div>
  );
}
